import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=7f8a8c53"
import script from "./CollectionList.vue?vue&type=script&lang=js"
export * from "./CollectionList.vue?vue&type=script&lang=js"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=7f8a8c53&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8a8c53')) {
      api.createRecord('7f8a8c53', component.options)
    } else {
      api.reload('7f8a8c53', component.options)
    }
    module.hot.accept("./CollectionList.vue?vue&type=template&id=7f8a8c53", function () {
      api.rerender('7f8a8c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CollectionList.vue"
export default component.exports